import { reactive, nextTick } from 'vue';

// Store an array of modal instances
const modalState = reactive({
    modals: [],
    nextId: 1,
});

// Base z-index for modals (Bootstrap default is around 1050)
const BASE_Z_INDEX = 1050;

function showModal(component, props = {}, events = {}, title = '', size = undefined, standaloneComponent = false) {
    const modalId = modalState.nextId++;
    
    const modal = {
        id: modalId,
        componentToRender: component,
        componentProps: props,
        eventHandlers: events,
        title,
        size,
        standaloneComponent,
        isVisible: false,
    };
    
    // Add the new modal to the stack
    modalState.modals.push(modal);
    
    // Trigger visibility on next tick to allow transition animation
    nextTick(() => {
        const modalInState = modalState.modals.find(m => m.id === modalId);
        if (modalInState) {
            modalInState.isVisible = true;
        }
    });
    
    // Return modal id so it can be closed specifically if needed
    return modalId;
}

function hideModal(modalId = null) {
    if (modalId === null) {
        // Close the topmost modal if no specific id provided
        if (modalState.modals.length > 0) {
            modalState.modals.pop();
        }
    } else {
        // Close a specific modal by id
        const index = modalState.modals.findIndex(m => m.id === modalId);
        if (index !== -1) {
            modalState.modals.splice(index, 1);
        }
    }
}

function hideAllModals() {
    modalState.modals = [];
}

function getZIndex(index) {
    // Each modal gets an incrementing z-index
    // Backdrop is at zIndex, modal is at zIndex + 10
    return BASE_Z_INDEX + (index * 20);
}

export function useModal() {
    return {
        modalState,
        showModal,
        hideModal,
        hideAllModals,
        getZIndex,
    };
}